import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { cn } from "../../lib/cn";

/**
 * Унифицированный заголовок страницы
 */
const PageHeader = ({
  title,
  subtitle,
  children, // Для кнопок действий
  backPath,
  onBack,
  className,
  titleClassName,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  const hasBackAction = backPath || onBack;

  return (
    <div className={cn("mb-8 space-y-4", className)}>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col md:flex-row md:items-center justify-between gap-6"
      >
        <div className="space-y-1 min-w-0">
          <div className="flex items-center gap-3">
            {hasBackAction && (
              <button
                onClick={handleBack}
                className="group p-2 -ml-2 hover:bg-[var(--color-bg-tertiary)] rounded-xl transition-all"
                title="Назад"
              >
                <svg
                  className="w-5 h-5 text-[var(--color-text-tertiary)] group-hover:text-[var(--color-primary)] transition-colors"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
            )}
            <h1
              className={cn(
                "text-2xl md:text-3xl font-black text-[var(--color-text-primary)] tracking-tight truncate",
                titleClassName,
              )}
            >
              {title}
            </h1>
          </div>
          {subtitle && (
            <div className="text-sm md:text-base text-[var(--color-text-secondary)] font-medium max-w-2xl">
              {subtitle}
            </div>
          )}
        </div>

        {children && (
          <div className="flex items-center gap-3 flex-wrap">{children}</div>
        )}
      </motion.div>
    </div>
  );
};

export default PageHeader;
